// extracted by mini-css-extract-plugin
module.exports = {"profilePic":"FallingDropdownMenu_profilePic__1QJU_"};